import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import Constants from "../business/Constants";
import CollectionPromoApi from "mbpromo/src/collection-api/CollectionPromoApi";
import Utility from "../business/Utility";
import Pristine from "pristinejs";

class AreaPersonaleCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);

		this.chat = new Promise((resolve) => {
			// eslint-disable-next-line no-undef
			if (typeof window.$ec === undefined) {
				if (!window.checkIntervalChat) {
					window.checkIntervalChat = setInterval(function () {
						// eslint-disable-next-line no-undef
						if (window.$ec) {
							clearInterval(window.checkIntervalChat);
							resolve();
						}
					}, 500);
				}
			} else {
				return resolve();
			}
		});

		this.init();

		Utility.enableHolidaysMessage();
		this.$pageContainer = $('.visual-background');
		this.emailLoggedUser = "";
		this.userCap="";
		this.userToken = Utility.getUrlParameter("t");
		this.usedToken = false;
		this.isValidToken = false;
		this.downloadBadgeEndpoint = window.API_ENDPOINT + `/api/mulinobianco/1.0/web/promo-engine/collection/colazione-2022/download/tessera/public`;
		this.userBadgeCode = "";
		this.addCpcAjaxInProgress = false;
		this.sendHomeInProgress = false;
		this.userID ="";
		this.submitAnagraficaInProgress = false;
		this.collectionPromoApi = new CollectionPromoApi({promoCode: Constants.API_PROMOCODE});
		this.addressValidationRegexp = /^[a-zA-Z0-9àáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð ,.'-/°]{2,120}$/;
	}

	isChatReady() {
		return this.chat;
	}

	getAreaPersonale(fromStep) {
		GigyaManager.getLoggedUserCached().then((u) => {
			this.emailLoggedUser = u.profile.email;
			this.userCap = u.profile.zip;
			this.userID = u.UID;

			Utility.trackEvent(this.userID,"PAGE_VIEW");

			this.collectionPromoApi.areaPersonale(this.userToken).then((resp)=>{
				let body = resp.body;

				this.isChatReady().then(() => {
					if (!body.registrato) {
						// eslint-disable-next-line no-constant-condition,no-undef
						window.$ec.addUserInfo({promozione: Constants.TRACKING_PROMOCODE, pagecode: document.location.href, browserName: Utility.getDeviceInfo().browserName, browserVersione: Utility.getDeviceInfo().browserVersion, osName: Utility.getDeviceInfo().osName, osVersione: Utility.getDeviceInfo().osVersion, device: Utility.getDeviceInfo().device});
					} else {
						// eslint-disable-next-line no-constant-condition,no-undef
						window.$ec.addUserInfo({idGigya: resp.body.gigya_uid, promozione: Constants.TRACKING_PROMOCODE, pagecode: document.location.href, browserName: Utility.getDeviceInfo().browserName, browserVersione: Utility.getDeviceInfo().browserVersion, osName: Utility.getDeviceInfo().osName, osVersione: Utility.getDeviceInfo().osVersion, device: Utility.getDeviceInfo().device, email: resp.body.email, telefono: resp.body.telefono, nome: resp.body.nome, cognome: resp.body.cognome});
					}
				});


				this.isValidToken = resp.body.isValidToken;

				if (!body.registrato) {
					this.buildLandingForm();
				} else {
					this.landingUser(body,fromStep);
				}

				Utility.removeLoader();
			}, ()=>{
				Utility.removeLoader();
			})
		}, () => {
			window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
		})
	}

	fillEditInfo(user) {
		$('.editData_data--name').html(`<b>${user.nome} ${user.cognome}</b>`);
		$('.editData_data--address').html(`${user.ind_denurb} ${user.ind_toponimo} ${user.ind_civico}`);
		$('.editData_data--city').html(user.citta);
	}

	sendBadgeModal(label) {
		$('.cpcSendHome').remove();

		let cpcTokenModal = ` 
 			<div class="feedback__modal cpcSendHome" component="FeedbackModalComponent">
				<div class="feedback__modal__wrap">
					<div class="feedback__modal__close" component-click="close()">
						<svg>
							<use xlink:href="#svg_circle_close"></use>
						</svg>
					</div>
					<div class="feedback__modal__content">
						<p>${label}</p>
					</div>
				</div>
			</div>
		`;
		Utility.removeLoader();
		$(this.element).append(cpcTokenModal);
		$('.cpcSendHome .feedback__modal__close').on('click', ()=>{
			Utility.startLoader();
			document.location.reload();
		});
		this.loadChildComponents(this);
	}

	sendBadge() {
		Utility.startLoader();
		if (!this.sendHomeInProgress) {
			this.sendHomeInProgress = true;
			this.collectionPromoApi.sendHome(this.userToken).then(()=>{
				this.usedToken = true;
				Utility.trackEvent(this.userID, "INVIO_TESSERA_HOME");
				this.sendHomeInProgress = false;
				this.sendBadgeModal(`Grazie per aver richiesto la tua tessera personalizzata, <br>la spediremo direttamente a casa tua.`);
			},(resp)=>{
				this.sendHomeInProgress = false;
				this.sendBadgeModal(resp.message);
			});
		}
	}

	landingUser(user,fromStep) {
		if (this.isValidToken && fromStep) {
			this.sendBadge();
		}

		//clean previous html
		let stepTitle = fromStep ? '<div class="step-counter"><span class="step-active">3 </span> di 3</div>' : '';

		$('.user-landing, .user-cpc, .prefooter-cnt').remove();
		let landingUserHtml = `
			<div class="main-cta content-wrapper-cnt user-landing">
				${stepTitle}
				<h2>Benvenuto nella tua Pagina Personale<br>della Raccolta Punti Colazione 2022!</h2>
				<p>In questa pagina trovi i servizi e vantaggi che Mulino Bianco ha riservato a chi come Te partecipa <br>alle sue iniziative più esclusive.</p>
				<div class="cpc-wrapper input-field">
					<span class="form-label">Il tuo <b>Codice Personale Collectioner</b> è:</span>
					<input type="text" name="user-cpc" readonly value="${user.codici_tessera[0]}">
					<span>Hai un altro Codice Personale Collectioner?<br><span class='other-cpc'>Clicca qui</span> per associare un nuovo codice</span>
				</div>
			</div>
		`;

		let cpcUserHtml = `
			<div class="main-cta content-wrapper-cnt user-cpc">
				<h2>Monitora lo stato di ogni tua tessera</h2>
				<p>Questa lista, sempre aggiornata, ti permette di tenere sotto controllo le richieste premio.</p>
			</div>
		`;

		this.$pageContainer.after(landingUserHtml);

		Utility.printUserPreFooter();

		$('.send-badge').on('click', () => {
			this.sendBadge();
		});

		$('.other-cpc').on('click', ()=> {
			this.otherCpc();
		});

		if(user.codici_tessera.length > 1) {
			let filterCPC = user.codici_tessera.slice(1);

			let otherCpcHtml = `
				<div class="otherCPC_wrapper content-wrapper-cnt">
					<span class="otherCPC_title"><b>Al tuo account sono associati anche i seguenti Codici Personali Collectioner:</b><br><br></span>
					${filterCPC.toString().replaceAll(',',', ')}
				</div>
			`;
			$('.otherCPC_wrapper').remove();
			$('.user-landing').append(otherCpcHtml);
		}

		let editDataCta = `
			<div class="editData_ctaWrapper">
				<h2 class="editData_title">I tuoi dati</h2>
				<p class="editData_subtitle">Aggiorna o modifica qui i tuoi dati personali!</p>
				<div class="editData_recap">
					<div class="editData_dataWrapper">
						<div class="editData_icon"></div>
						<div class="editData_data">
							<div class="editData_data--name"></div>
							<div class="editData_data--address"></div>
							<div class="editData_data--city"></div>
						</div>
					</div>
					<a href="/promozioni/raccolta-punti-colazione/modifica-dati" class="editData_cta button">Modifica</a>
				</div>
			</div>
		`;

		$('.user-landing').append(editDataCta);
		this.fillEditInfo(user);

		// eslint-disable-next-line no-constant-condition
		if(user.premi_richiesti.length > 0) {
			$('.user-landing').after(cpcUserHtml);

			let awardImg, awardTitle = "";
			let otherCpcClass = user.codici_tessera.length == 1 ? "uniqueCPC" : "";

			$.each(user.premi_richiesti, function() {
				this.codice_premio == 'COC22' ? (awardImg = 'user-coccio.png', awardTitle = 'Coccio delle Origini 2022') : (this.codice_premio == 'BISCO22' ? (awardImg = 'user-biscotazza.png', awardTitle = 'Biscotazza 2022') : (awardImg = 'user-mattutina.png', awardTitle = 'La Mattutina'));
				let protocolId = (this.protocollo != undefined)
					? `<span class="award-request-protocolId">Numero richiesta premio: <strong>${this.protocollo}</strong></span>`
					: '';
				$('.user-cpc').append(`
					<div class="award-request ${otherCpcClass}">
						<div class="award-request-image">
							<img src="https://static.mulinobianco.it/v3/pew/COLLECTION_COLAZIONE_2022/assets/img/premi/${awardImg}" alt="premio">
						</div>
						<div class="award-request-points-cnt">
							<span class="award-request-points">${this.punti_premio}</span>
							<span class="award-request-points-label">punti</span>
						</div>
						<div class="award-request-date-cnt">
							<span class="award-request-date">${this.data_richiesta_premio}</span>
							<span class="award-request-date-label">Richiesta premio<br>${awardTitle}</span>
							${protocolId}
							<span class="award-request-cpc">Codice Personale Collectioner utilizzato: ${this.codice_tessera}</span>
						</div>
						<div class="award-request-status">
							<div class="button button--gold">${this.stato_premio}</div>
						</div>
					</div>
				`);
			})
		} else {
			let noAwardHtml = `
				<div class="main-cta content-wrapper-cnt user-cpc">
					<h2>Monitora lo stato di ogni tua tessera</h2>
					<p>Questa lista, sempre aggiornata, ti permette di tenere sotto controllo le richieste premio.</p>
					<p><b>Al momento non hai ancora richiesto nessun premio</b></p>
				</div>
			`;
			$('.user-landing').after(noAwardHtml);
		}
	}

	otherCpc() {
		let otherCpcModal = ` <div class="feedback__modal other-cpc-modal" component="FeedbackModalComponent">
							<div class="feedback__modal__wrap">
							<div class="feedback__modal__close" component-click="close()">
									<svg>
										<use xlink:href="#svg_circle_close"></use>
									</svg>
								</div>
								<div class="feedback__modal__content">
									<p style="font-weight: bold;">Associa un Codice Personale Collectioner</p>
									<input style="margin-bottom: 30px" type="text" name="otherCpc" placeholder="00000000" maxlength="8">
								</div>
								<div class="feedback__modal__cta-cnt cta-cpc">
									<span class="other-cpc-message" style="display:none"></span>
									<div class="button add-cpc" >Conferma</div>
								</div>
							</div>
						</div>
				   `;

		$(this.element).append(otherCpcModal);
		this.loadChildComponents(this);

		$('.add-cpc').on('click', ()=> {
			if ($('[name="otherCpc"]').val().length != 0) {
				if (!this.addCpcAjaxInProgress) {
					this.addCpcAjaxInProgress = true;
					this.collectionPromoApi.insertTessera($('[name="otherCpc"]').val()).then(()=>{
						$('.other-cpc-message').html('').html('Codice inserito con successo!').removeClass('error').show();
						Utility.trackEvent(this.userID,"INSERT_TESSERA");
						this.addCpcAjaxInProgress = false;
						$('.other-cpc-modal').remove();
						this.getAreaPersonale(false);
					},(resp)=>{
						if (!resp.body.error_message) {
							$('.other-cpc-message').addClass('error').html('').html('Ops, qualcosa è andato storto!').show()
						} else {
							$('.other-cpc-message').addClass('error').html('').html(resp.body.error_message).show();
						}
						this.addCpcAjaxInProgress = false;
					});
				}
			} else {
				$('.other-cpc-message').addClass('error').html('Inserire un codice valido').show();
			}
		});
	}

	buildLandingForm() {
		let landingFormHtml = `
			<div class="main-cta content-wrapper-cnt landing-form">
				<div class="step-counter"><span class="step-active">1 </span> di 3</div>
				<h2>Premiati a colazione!</h2>
				<p>Completa in pochi passaggi la tua registrazione alla Raccolta Punti: sarai sempre aggiornato sulle novità , potrai accedere a tutti i servizi riservati a chi è un consumatore fedele come te, verificare in ogni momento lo stato delle tue richieste premio e stampare le tessere personalizzate e con i Punti OMAGGIO!<br><br>Colleziona i <b>Punti Colazione 2022</b> per ricevere gli esclusivi premi per la colazione.</p>
				<form class="progress-registration">
					<div class="email-wrapper input-field">
						<label class="form-label">Qui di seguito la mail con cui sarà personalizzata la Tessera e su cui riceverai tutte le comunicazioni <br>inerenti la gestione di questa raccolta</label>
						<input name="email" type="email" readonly class="gigya-autocomplete-email">
					</div>
					<div class="cpc-wrapper input-field">
						<label class="form-label">Inserisci il tuo <b>Codice Personale Collectioner</b></label>
						<input name="cpc" type="text" placeholder="00000000">
					</div>
					<div class="proceed-wrapper input-field">
						<span class="form-label">Non hai ancora il <b>Codice Personale Collectioner</b> di questa raccolta?<br>Nessun problema! Clicca su Procedi e te ne verrà assegnato uno.</span>
						<div class="submit-cnt">
							<div class="button">Procedi</div>
							<span class="error" style="display: none"></span>
						</div>
						<span class="form-label">Attenzione! L’iniziativa è riservata ai maggiorenni.</span>
					</div>
				</form>
			</div>
		`;
		this.$pageContainer.after(landingFormHtml);
		// eslint-disable-next-line no-undef
		gigyaIntegration.autocompleteForm('.progress-registration');
		let userCap = this.userCap;

		$('.landing-form .button').on('click', ()=> {
			//inserire check numero tessera, se presente
			Utility.startLoader();

			this.collectionPromoApi.precompilazione(this.emailLoggedUser,$("[name='cpc']").val()).then((resp)=>{
				let body = resp.body;

				$('.landing-form').hide().html('');
				this.buildForm();

				if (body.codice_tessera) {
					this.userBadgeCode = body.codice_tessera;
				}

				if (body.precompilazione == false) {
					// eslint-disable-next-line no-undef
					gigyaIntegration.autocompleteForm('.registered-user', this.fillCapProvCityForm(userCap));
					$("[name='firstName']").attr('readonly','readonly');
					$("[name='lastName']").attr('readonly','readonly');
					this.prepareCap(true);
				} else {
					this.preCompileForm(body.precompilazione);
					this.prepareCap(false);
				}

				Utility.removeLoader();
			}, (resp)=>{
				$('.error').html('').html(resp.message).show();
				Utility.removeLoader();
			});
		});
	}

	preCompileForm(data) {
		if (data.nome) {
			$("[name='firstName']").val(data.nome).attr('readonly','readonly');
		}
		if (data.cognome) {
			$("[name='lastName']").val(data.cognome).attr('readonly','readonly');
		}
		if(data.ind_toponimo) {
			$("[name='address']").val(data.ind_toponimo);
		}
		if (data.citofono) {
			$("[name='notes']").val(data.citofono);
		}
		if (data.ind_denurb) {
			$("[name='addressType']").val(data.ind_denurb.toUpperCase());
		}
		if (data.ind_civico) {
			$("[name='addressNum']").val(data.ind_civico);
		}
		if (data.cap) {
			$("[name='cap']").val(data.cap);
		}
		if (data.provincia) {
			$("[name='prov']").val(data.provincia);
		}
		if (data.citta) {
			$("[name='city']").html('').append(`<option value="${data.citta}" selected>${data.citta}</option>`);
		}
		if (data.telefono) {
			$("[name='tel']").val(data.telefono != null ? data.telefono : (data.cellulare != null ? data.cellulare : ''));
		}
	}

	prepareCap(fillOnLoad) {
		let self = this;
		$('[name="cap"]').on('input change', function() {
			self.fillCapProvCityForm($('[name="cap"]').val());
		});

		if (fillOnLoad) {
			this.fillCapProvCityForm($('[name="cap"]').val());
		}
	}

	fillCapProvCityForm(cap) {
		if (cap && cap.length == 5) {
			this.collectionPromoApi.capUtil(3, {"cap": cap}).then((resp) => {
				if (resp.body.localita[0]) {
					let checkSelected = resp.body.localita.length == 1 ? 'selected' : '';
					Utility.startLoader();
					let body = resp.body.localita[0];

					$('[name="cap"]').val(cap);
					$('[name="city"]').html('');
					if (resp.body.localita.length > 1) {
						$('[name="city"]').append(`<option selected disabled value="">Seleziona...</option>`);
					}

					$.each(resp.body.localita, function() {
						$('[name="city"]').append(`<option value="${this.nome}" ${checkSelected}>${this.nome}</option>`);
					})

					$('[name="prov"]').val(body.provincia);
					$('.location-cnt .pristine-error').html('').hide();
					Utility.removeLoader();
				} else {
					$('[name="city"]').html('');
					$('[name="city"]').val('')
					$('[name="prov"]').val('');
				}
			}, (resp) => {
				console.log(resp.message)
			})
		}
	}

	buildForm() {
		let registeredUserFormHtml = Utility.buildForm(false, this.emailLoggedUser);

		this.$pageContainer.after(registeredUserFormHtml);
		this.confirmData();
	}

	init() {
		this.loadChildComponents(this);
		Utility.startLoader();
		this.getAreaPersonale(false);
	}

	confirmData() {
		$('.registered-user .proceed').on('click', (e)=> {
			e.preventDefault();
			$('.confirm__user').remove();

			let tmplModalGeneric = ` <div class="feedback__modal confirm__user" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                    <div class="feedback__modal__close" component-click="close()" style="display:none;">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                        	<div class="feedback__modal__icon--bell"></div>
                                                            <p>Vuoi aggiornare il tuo profilo con i dati che hai appena inserito?<br>
																Se sì, clicca “aggiorna". Ti ricordiamo che puoi modificare i dati
																in qualsiasi momento accedendo al tuo profilo.</p>
                                                        </div>
                                                        <div class="feedback__modal__cta-cnt">
															<div class="button update-user" >Aggiorna</div>
															<div class="button button--gold dontupdate-user">Non aggiornare</div>
														</div>
														<div class="feedback__modal__error"></div>
                                                    </div>
                                                </div>
                                               `;
			let pristine = new Pristine(document.getElementById("registered-user-form"),{

			});
			pristine.addValidator($('[name="address"]')[0], (value) => {
				// here `this` refers to the respective input element
				if (!this.addressValidationRegexp.test(value)){
					return false;
				}
				return true;
			}, "Il campo contiene caratteri non consentiti", 2, false);

			pristine.addValidator($('[name="notes"]')[0], (value) => {
				// here `this` refers to the respective input element
				if (!this.addressValidationRegexp.test(value)){
					return false;
				}
				return true;
			}, "Il campo contiene caratteri non consentiti", 2, false);

			let valid = pristine.validate(); // returns true or false

			if (valid) {
				$(this.element).append(tmplModalGeneric);
				this.loadChildComponents(this);

				$('.confirm__user .update-user').on('click', ()=> {
					Utility.startLoader();
					window.gigyaIntegration.saveForm('.registered-user');
					this.createAnagrafica();
				});
				$('.confirm__user .dontupdate-user').on('click', ()=> {
					Utility.startLoader();
					this.createAnagrafica();
				});
			}
		})
	}

	anagraficaData() {
		let data;
		if (this.userBadgeCode !== "") {
			data = {
				"codice_tessera": this.userBadgeCode,
				"nome": $("[name='firstName']").val(),
				"cognome": $("[name='lastName']").val(),
				"email": this.emailLoggedUser,
				"ind_denurb": $("[name='addressType']").val(),
				"ind_toponimo": $("[name='address']").val(),
				"ind_civico": $("[name='addressNum']").val(),
				"citofono": $("[name='notes']").val(),
				"cap": $("[name='cap']").val(),
				"citta": $("[name='city']").val(),
				"provincia": $("[name='prov']").val(),
				"telefono": $("[name='tel']").val()
			}
		} else {
			data = {
				"nome": $("[name='firstName']").val(),
				"cognome": $("[name='lastName']").val(),
				"email": this.emailLoggedUser,
				"ind_denurb": $("[name='addressType']").val(),
				"ind_toponimo": $("[name='address']").val(),
				"ind_civico": $("[name='addressNum']").val(),
				"citofono": $("[name='notes']").val(),
				"cap": $("[name='cap']").val(),
				"citta": $("[name='city']").val(),
				"provincia": $("[name='prov']").val(),
				"telefono": $("[name='tel']").val()
			}
		}
		return data;
	}

	createAnagrafica() {
		GigyaManager.addCH(Constants.CH_PROMO).then(() => {
			if (!this.submitAnagraficaInProgress) {
				this.submitAnagraficaInProgress = true;
				$('.error-anagrafica').remove();
				this.collectionPromoApi.createAnagrafica(this.anagraficaData()).then(()=>{
					$('.feedback__modal, .user-register-form').remove();
					this.getAreaPersonale(true);
					Utility.removeLoader();
					this.submitAnagraficaInProgress = false;
					Utility.trackEvent(this.userID,"INSERT_ANAGRAFICA");
				}, (resp)=>{
					this.submitAnagraficaInProgress = false;
					$('.cta-cnt').before(`<div class="error-anagrafica">${resp.body.error_message}</div>`);
					$('.feedback__modal').remove();
					Utility.removeLoader();
				});
			}
		}, () => {
			let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h3 class="h3">Ops, qualcosa è andato storto! </h3>
                                                            <p>Ti preghiamo di riprovare più tardi!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
			$(this.element).append(tmplModalGeneric);
			this.loadChildComponents(this);
			Utility.removeLoader();
		})
	}
}

export default AreaPersonaleCtrl;
